



















import Vue, { PropType } from 'vue'
import Panel from './Panel.vue'
import { CreditCard, PaymentMethod } from '@/types/generated/graphql'

type Data = {
  paymentMethod: typeof PaymentMethod
}

type Props = {
  partnerPaymentMethod: PaymentMethod
  creditCard: CreditCard | null
}

export default Vue.extend<Data, {}, {}, Props>({
  name: 'PartnerPaymentMethod',
  components: { Panel },
  data() {
    return {
      paymentMethod: PaymentMethod,
    }
  },
  props: {
    partnerPaymentMethod: {
      type: String as PropType<PaymentMethod>,
      required: true,
    },
    creditCard: {
      type: Object as PropType<CreditCard>,
      required: false,
    },
  },
})
